<template>
  <div class="account-management">
    <!-- 搜索条件 -->
    <div class="search-container">
      <el-form :model="searchForm" label-width="80px" inline>
        <el-form-item label="账号">
          <el-input v-model="searchForm.account" placeholder="请输入账号" clearable />
        </el-form-item>
        <el-form-item>
          <el-button @click="handleSearch" class="search_button">搜索</el-button>
          <el-button @click="handleReset" class="button">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 添加按钮 -->
    <div class="toolbar">
      <el-button type="primary" @click="handleAddAccount">添加黑名单</el-button>
    </div>

    <!-- 数据表格 -->
    <div class="table-container">
      <el-table :data="tableData" v-loading="loading" style="width: 100%" :row-style="{ height: '80px' }"
        :header-cell-style="{ color: '#333', fontWeight: 'bold', fontsize: '14px' }">
        <el-table-column prop="mobile" label="账号" min-width="120" />
        <el-table-column prop="createTime" label="创建时间" width="180">
          <template #default="scope">
            {{ formatDateTime(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="320">
          <template #default="scope">
            <el-button size="small" @click="handleWhiteListStatus(scope.row)" class="delete-button" type="danger" >取消黑名单</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-config-provider :locale="zhCn">
          <el-pagination v-model:current-page="pagination.currentPage" v-model:page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]" :total="pagination.total" layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </el-config-provider>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'WhiteListManage'
  } 
</script>

<script setup>
import { ref, reactive, onMounted, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

// 路由实例
const router = useRouter()
const { proxy } = getCurrentInstance();

// 搜索表单
const searchForm = reactive({
  account: '',
  status: ''
})

// 分页数据
const pagination = reactive({
  currentPage: 1,
  pageSize: 10,
  total: 0
})

// 表格数据
const tableData = ref([])
const loading = ref(false)


// 搜索功能
const handleSearch = () => {
  pagination.currentPage = 1
  fetchData()
}

// 重置搜索
const handleReset = () => {
  searchForm.account = ''
  searchForm.status = ''
  pagination.currentPage = 1
  fetchData()
}

// 添加账号
const handleAddAccount = () => {
  router.push('/houseCart/addWhiteListManage');
}




// 切换账号状态
const handleWhiteListStatus = (row) => {


  ElMessageBox.confirm(
    `确定要取消账号 "${row.mobile}"的黑名单吗？`,
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }
  ).then(() => {
    // 模拟API调用
    let url = '/login/updateWhiteList';
    proxy.$tools.request(url,
      { reqBody: { mobileNo: row.mobile } }
    ).then(response => {
      const code = response.data.rspHead.returnCode;
      if (code === '00000000') {
        ElMessage.success('操作成功');
        fetchData();
      } else {
        ElMessage.error('系统异常，请联系管理员' + response.data.rspHead.returnMsg);
      }
    }).catch(error => {
      // 处理错误情况
      ElMessage.error('系统异常，请联系管理员' + error);
    });
  }).catch(() => {
    // 取消操作的逻辑（可选）
    // 这里可以留空或者添加取消后的处理逻辑
  })
}


// 分页相关
const handleSizeChange = (val) => {
  pagination.pageSize = val
  fetchData()
}

const handleCurrentChange = (val) => {
  pagination.currentPage = val
  fetchData()
}

// 获取数据
const fetchData = () => {
  loading.value = true
  let url = '/login/queryWhiteList';
  proxy.$tools.request(url,
    {
      reqBody: {
        mobileNo: searchForm.account,
        status: searchForm.status,
        pageNo: pagination.currentPage,
        pageSize: pagination.pageSize
      }
    }
  ).then(response => {
    const code = response.data.rspHead.returnCode;
    if (code === '00000000') {
      tableData.value = response.data.rspBody.userList;
      pagination.total = response.data.rspBody.total;
      loading.value = false
    } else {
      ElMessage.error('系统异常，请联系管理员' + response.data.rspHead.returnMsg);
    }
  }).catch(error => {
    // 处理错误情况
    ElMessage.error('系统异常，请联系管理员' + error);
  });
}

const formatDateTime = (dateString) => {
  const date = new Date(dateString)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

// 初始化数据
onMounted(() => {
  // fetchData()
})
</script>

<style scoped>
.account-management {
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 10px;
}

.search-container {
  /* background-color: #f5f7fa; */
  padding: 20px;
  border-radius: 4px;
  /* margin-bottom: 10px; */
}

.select-width {
  width: 150px;
}

.toolbar {
  /* margin-bottom: 10px; */
  text-align: left;
}

.table-container {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.pagination-container :deep(.el-pagination) {
  font-size: 13px;
  font-weight: 400;
}

.pagination-container :deep(.el-pagination .el-pager li) {
  font-size: 13px;
  min-width: 30px;
  height: 30px;
  line-height: 30px;
}

.pagination-container :deep(.el-pagination .el-pagination__total) {
  font-size: 13px;
  color: #666;
}

.pagination-container :deep(.el-pagination .el-pagination__jump) {
  font-size: 13px;
  color: #666;
}

.pagination-container :deep(.el-pagination .el-input__inner) {
  font-size: 14px;
  height: 25px;
}

.pagination-container :deep(.el-pagination button) {
  font-size: 14px;
  min-width: 30px;
  height: 30px;
  padding: 0 8px;
}

.pagination-container :deep(.el-pagination .el-select) {
  font-size: 10px;
  width: 100px;
  margin: 0 10px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

.search_button {
  background-color: #2b82cf;
  width: 80px;
  height: 35px;
  border: 1px solid #2b82cf;
  border-radius: 4px;
  font-size: 14px;
  color: #fff;
}

.search_button:hover {
  background-color: #409eff;
  color: #fff;
}

.button {
  width: 100px;
  height: 35px;
  border: 1px solid #2b82cf;
  border-radius: 4px;
  font-size: 14px;
  color: #2b82cf;
}
.delete-button {
  width: 100px;
  height: 35px;
  /* border: 1px solid #2b82cf; */
  border-radius: 4px;
  font-size: 14px;
  color: #ffffff; 
  font-weight: 500;
}
@media (max-width: 768px) {
  
}
</style>
